<template>
  <div>
    <Header v-show="this.$store.getters['user/getUserLoadStatus']()"></Header>
    <Menu v-show="this.$store.getters['user/getUserLoadStatus']()"></Menu>

    <section
      id="overlay"
      v-show="this.$store.state.overlay_is_visible"
      @click="closeOverlay()"
    ></section>

    <section
      id="loading"
      v-show="this.$store.state.is_loading"
    ></section>

    <section id="container">
      <router-view />
    </section>

    <UploadList></UploadList>
    <Footer></Footer>
  </div>
</template>

<script>

import Header from '@/components/layout/admin/Header'
import Menu from '@/components/layout/admin/Menu'
import UploadList from '@/components/layout/admin/UploadList'
import Footer from '@/components/layout/Footer'

import { Api } from '@/core/api.js'
const api = new Api()

export default {
  components: { Header, Menu, Footer, UploadList },
  methods: {
    closeOverlay () {
      this.$store.commit('setOverlayVisible', false)
    }
  },
  created () {
    this.$store.commit('setMenuVisible', false)
  },
  async mounted() {
    const market = this.$store.getters.getMarket; 
    await this.$store.dispatch('locations/loadMenu');
  }
}
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#container {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  max-width: 200vh;
}
</style>
